import { render, staticRenderFns } from "./FollowupTypes.vue?vue&type=template&id=e75bf9a6&scoped=true"
import script from "./FollowupTypes.vue?vue&type=script&lang=js"
export * from "./FollowupTypes.vue?vue&type=script&lang=js"
import style0 from "./FollowupTypes.vue?vue&type=style&index=0&id=e75bf9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75bf9a6",
  null
  
)

export default component.exports